import { authRequest } from "src/engine/modules/authRequest"
import { showToast } from "@infotech/uikit-toasts"
import * as entity from "src/engine/modules/entity"

export const deletePlanWithEvents = ({ id, uuid, model, dispatch, name }) => {
  authRequest({
    url: `/plans/${uuid}`,
    method: `delete`,
    params: { withEvents: true },
  })
    .then(() => {
      dispatch(entity.actions.creators.remove.success(model, id, true))
      showToast({
        type: `success`,
        message: `План ${name} успешно удален со всеми событиями.`,
        hideIn: 5,
      })
    })
    .catch(error => {
      showToast({
        type: `error`,
        message: `${error.message}`,
        hideIn: 5,
      })
    })
}
